import { render, staticRenderFns } from "./ItemEmpty.vue?vue&type=template&id=152a7dea&scoped=true&"
import script from "./ItemEmpty.vue?vue&type=script&lang=js&"
export * from "./ItemEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ItemEmpty.vue?vue&type=style&index=0&id=152a7dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152a7dea",
  null
  
)

export default component.exports